import { useMutation } from '@tanstack/react-query';

import { matchCompany } from './matchCompany';
import {
  type MatchCompanyMutationOptions,
  type MatchCompanyRequest,
} from './types';

/**
 * Custom hook for checking if a company with a similar name and address already exists.
 *
 * @param options - Optional mutation options.
 * @returns An object containing the mutation function and related properties.
 *
 * @see https://app.dev.vestigas.com/redoc#tag/VESTIGAS-Admin-Company/operation/get_company_match_by_name_and_address_vadmin_company_match_post
 */
export const useMutationMatchCompany = (
  options?: MatchCompanyMutationOptions,
) =>
  useMutation({
    mutationFn: async (data: MatchCompanyRequest) => matchCompany(data),
    ...options,
  });
